var $8165adf786eb9d46$exports = {};
$8165adf786eb9d46$exports = {
    "loading": `Y\xfckleniyor...`,
    "loadingMore": `Daha fazla y\xfckleniyor...`
};


export {$8165adf786eb9d46$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
